module.exports = __webpack_public_path__ + "img/ki.472c5f4a.svg";